/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationVariables = GraphQL.Exact<{
  alertDefinitionId: GraphQL.Scalars['AlertDefinitionId']['input'];
  messagingAppChannelIds: ReadonlyArray<GraphQL.Scalars['ID']['input']> | GraphQL.Scalars['ID']['input'];
  recipients: GraphQL.Scalars['Array']['input'];
  segmentChangeSizePercentage: GraphQL.Scalars['Percentage']['input'];
  segmentChangeType: GraphQL.Scalars['String']['input'];
  segmentName: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation = { readonly __typename?: 'Mutation', readonly UpdatePagesEnteredOrLeftSegmentAlertDefinition: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly alertDefinitions: ReadonlyArray<{ readonly __typename?: 'AlertDefinition', readonly alertType: string, readonly id: CK.AlertDefinitionId, readonly recipients: ReadonlyArray<string>, readonly scope: string, readonly settings: Record<string, any>, readonly messagingAppChannels: ReadonlyArray<{ readonly __typename?: 'MessagingAppChannel', readonly id: CK.ID, readonly label: string, readonly messagingAppType: GraphQL.MessagingAppType }> }>, readonly integrations: ReadonlyArray<{ readonly __typename?: 'WebsiteIntegration', readonly isNotOwned: boolean, readonly status: GraphQL.WebsiteIntegrationStatus, readonly type: GraphQL.WebsiteIntegrationType }> } | null } } };


export const UpdatePagesEnteredOrLeftSegmentAlertDefinitionDocument = gql`
    mutation UpdatePagesEnteredOrLeftSegmentAlertDefinition($alertDefinitionId: AlertDefinitionId!, $messagingAppChannelIds: [ID!]!, $recipients: Array!, $segmentChangeSizePercentage: Percentage!, $segmentChangeType: String!, $segmentName: String!, $websiteId: WebsiteId!) {
  UpdatePagesEnteredOrLeftSegmentAlertDefinition(
    alertDefinitionId: $alertDefinitionId
    messagingAppChannelIds: $messagingAppChannelIds
    recipients: $recipients
    segmentChangeSizePercentage: $segmentChangeSizePercentage
    segmentChangeType: $segmentChangeType
    segmentName: $segmentName
    websiteId: $websiteId
  ) {
    query {
      website(id: $websiteId) {
        alertDefinitions {
          alertType
          id
          messagingAppChannels {
            id
            label
            messagingAppType
          }
          recipients
          scope
          settings
        }
        id
        integrations {
          isNotOwned
          status
          type
        }
      }
    }
  }
}
    `;
export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationFn = Apollo.MutationFunction<UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation, UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationVariables>;

/**
 * __useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePagesEnteredOrLeftSegmentAlertDefinitionMutation, { data, loading, error }] = useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation({
 *   variables: {
 *      alertDefinitionId: // value for 'alertDefinitionId'
 *      messagingAppChannelIds: // value for 'messagingAppChannelIds'
 *      recipients: // value for 'recipients'
 *      segmentChangeSizePercentage: // value for 'segmentChangeSizePercentage'
 *      segmentChangeType: // value for 'segmentChangeType'
 *      segmentName: // value for 'segmentName'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation, UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation, UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationVariables>(UpdatePagesEnteredOrLeftSegmentAlertDefinitionDocument, options);
      }
export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationHookResult = ReturnType<typeof useUpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation>;
export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationResult = Apollo.MutationResult<UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation>;
export type UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutation, UpdatePagesEnteredOrLeftSegmentAlertDefinitionMutationVariables>;